import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Button } from '@mui/material';

import { StateDisplay } from './StateDisplay';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * Shown when a query/mutation failed after retry: plain-language explanation and a retry action,
 * never a raw GraphQL error string or stack trace (docs/development/FrontendGuidelines.md §7.10/§9.2). A
 * user-initiated retry always re-issues the exact same query/mutation (§9.5).
 */
export function ErrorState({
  title = 'We hit a snag',
  message = 'Something went wrong. Please try again.',
  onRetry,
}: ErrorStateProps) {
  return (
    <StateDisplay
      tone="error"
      icon={<ErrorOutlineIcon />}
      title={title}
      description={message}
      actions={
        onRetry ? (
          <Button variant="outlined" onClick={onRetry}>
            Try again
          </Button>
        ) : undefined
      }
    />
  );
}
